var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIotOne(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 61 60",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 1.5
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "iotOne"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 30.214,
    cy: 30.045,
    r: 29.946,
    style: {
      fill: "#4888ad"
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 11.504,
    y: 16.274,
    width: 37.997,
    height: 28.483,
    style: {
      fill: "#fff",
      stroke: "##4888ad",
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M28.081,23.315l1.64,-0.001",
    style: {
      fill: "none",
      stroke: "#4888ad",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.53,23.312l10.671,-0.006",
    style: {
      fill: "none",
      stroke: "#4888ad",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 31.626,
    cy: 23.306,
    rx: 1.905,
    ry: 1.921,
    style: {
      fill: "#fff",
      stroke: "#4888ad",
      strokeWidth: 2
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M28.081,37.156l1.64,-0.001",
    style: {
      fill: "none",
      stroke: "#4888ad",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.53,37.153l10.671,-0.006",
    style: {
      fill: "none",
      stroke: "#4888ad",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 31.626,
    cy: 37.147,
    rx: 1.905,
    ry: 1.921,
    style: {
      fill: "#fff",
      stroke: "#4888ad",
      strokeWidth: 2
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M44.201,30.506l-1.64,0.001",
    style: {
      fill: "none",
      stroke: "#4888ad",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.752,30.509l-10.671,0.006",
    style: {
      fill: "none",
      stroke: "#4888ad",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 40.656,
    cy: 30.515,
    rx: 1.905,
    ry: 1.921,
    style: {
      fill: "#fff",
      stroke: "#4888ad",
      strokeWidth: 2
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer5"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.289,29.683l-0.06,-5.318l3.209,-2.755l3.517,2.882l0.01,5.125l-6.676,0.066Z",
    style: {
      fill: "#fff",
      stroke: "#4888ad",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.489,24.991l0.74,-0.626",
    style: {
      fill: "none",
      stroke: "#4888ad",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.728,25.147l-0.926,-0.782",
    style: {
      fill: "none",
      stroke: "#4888ad",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.489,29.683l8.239,0",
    style: {
      fill: "none",
      stroke: "#4888ad",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 21.268,
    y: 26.168,
    width: 0.708,
    height: 2.751,
    style: {
      fill: "#fff",
      stroke: "#4888ad",
      strokeWidth: 2
    }
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIotOne);
export default __webpack_public_path__ + "static/media/iotOne.75405bc7fd8c3366205aecbeb2fa261c.svg";
export { ForwardRef as ReactComponent };